//import { Token } from "typescript";
import { actionCreatorFactory } from "typescript-fsa";
import {LanguageModel} from '../typing/generalLoginType';

const actionCreator = actionCreatorFactory("LanguageMana");


const languageChange = actionCreator<{Language:LanguageModel}>("ChangeLanguage");
const toggleLanguage = actionCreator<{}>("toggleLanguage");

export const languageActions = {languageChange, toggleLanguage};